export const props = Object.freeze({
  /**
   * The languages the record's fields can be translated into: `[{ locale, name }]`, as a JSON
   * attribute or an array property.
   * @type {Array|String}
   * @default []
   */
  languages: {
    type: [Array, String],
    default: () => [],
  },
  /**
   * Locale of the untranslated text, matching the `default-locale` of the page's fields.
   * @type {String}
   * @default "en"
   */
  defaultLocale: {
    type: String,
    default: "en",
  },
  /**
   * Name of the untranslated text's language, shown in the selector.
   * @type {String}
   * @default undefined
   */
  defaultLanguageName: {
    type: String,
    default: undefined,
  },
  /**
   * Type of the record being edited (`Physician`). Sent with a Clara request.
   * @type {String}
   * @default undefined
   */
  resourceType: {
    type: String,
    default: undefined,
  },
  /**
   * Id of the record being edited. Sent with a Clara request.
   * @type {String|Number}
   * @default undefined
   */
  resourceId: {
    type: [String, Number],
    default: undefined,
  },
  /**
   * Endpoint a Clara request is posted to. Without it the toolbar offers no Clara action.
   * @type {String}
   * @default undefined
   */
  translateUrl: {
    type: String,
    default: undefined,
  },
});
